import React from 'react';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" aria-labelledby="pain-heading" data-id="element-255" data-mp="1twgy0yfp2mct">
      <div className="mx-auto max-w-4xl" data-id="element-256" data-mp="27nvfh0tyefhr">
        <p className="text-center font-display text-sm font-extrabold uppercase tracking-widest text-danger" data-id="element-257" data-mp="22vlve1fis9ne">Does this sound familiar?</p>
        <h2 id="pain-heading" className="mt-3 text-center font-display text-[1.7rem] font-black leading-tight text-navy-950 sm:text-4xl" data-id="element-258" data-mp="2hjf9tisvd64e">
          Have You Ever Experienced Any of These Situations?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-base text-ink/70" data-id="element-259" data-mp="2qjvcwr5pab8q">If even one sounds familiar, this roadmap was designed to help you organize your approach.</p>

        <ol className="mt-10 space-y-4" data-id="element-260" data-mp="w6djwomj0m6b">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 rounded-2xl bg-cream p-5 sm:p-6" data-id="element-261" data-mp="s5topqlijsmt" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy-900 font-display text-lg font-black text-gold-300" data-id="element-262" data-mp="1n7tmmasdhndq">{i + 1}</span>
              <div data-id="element-263" data-mp="1s768as7icoeq">
                <h3 className="font-display text-lg font-extrabold leading-snug text-navy-950" data-id="element-264" data-mp="1s4jz6o4yy0ue">{p.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink/75" data-id="element-265" data-mp="21wpsq2avcqbp">{p.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-266" data-mp="26v0zu59s4mq8">
          <CTAButton label="Yes! I want a clear planning process" sublabel="Leave the guesswork behind" data-id="element-267" data-mp="26xvl1z0mabkp" />
        </div>
      </div>
    </section>;
}